/** Rejim: yorug' / qorong'i / tizim. Tanlov brauzerda eslab qolinadi; `.dark` klassi <html> da. */

export type ThemeMode = "light" | "dark" | "system";
export const THEME_KEY = "ep.theme";
export const THEME_ORDER: ThemeMode[] = ["system", "light", "dark"];

export function readMode(): ThemeMode {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function isDark(mode: ThemeMode, systemDark: boolean): boolean {
  return mode === "dark" || (mode === "system" && systemDark);
}

export function applyMode(mode: ThemeMode, root: HTMLElement = document.documentElement): void {
  const systemDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  const dark = isDark(mode, systemDark);
  root.classList.toggle("dark", dark);
  root.style.colorScheme = dark ? "dark" : "light"; // brauzer elementlari (scroll, forma) ham mos bo'lsin
}

export function saveMode(mode: ThemeMode): void {
  try {
    if (mode === "system") localStorage.removeItem(THEME_KEY);
    else localStorage.setItem(THEME_KEY, mode);
  } catch {
    /* private rejim: shu sessiyada ishlaydi */
  }
}

export const nextMode = (m: ThemeMode): ThemeMode =>
  THEME_ORDER[(THEME_ORDER.indexOf(m) + 1) % THEME_ORDER.length]!;
